<div class="list-item" [ngClass]="{'notes-list': hasNotesCount, 'on-preview': displayed}">

    <div class="details">
        <span class="title" (click)="actionClickFile(file,$event)">{{file.name}}</span>
        <span class="download-icon" title="Download" (click)="actionDownloadClick(file,$event)"></span>
        <span class="size">({{humanFileSize(file.size)}})</span>
        <span class="ext">{{getFileExtension(file.name)}}</span>
        <ng-container *ngIf="hasNotesCount && notesCount > 0">
            <core-helpers-icons-notes-counter-bubble
                [title]= "notesCount+' notes'"
                [letter]="notesCount"
                (actionClick)="actionClick.emit(file)"
            ></core-helpers-icons-notes-counter-bubble>
        </ng-container>
    </div>
    
    <core-helpers-navigation-three-dots-menu [menu]="menu" (action)="onMenuSelect($event)"></core-helpers-navigation-three-dots-menu>

</div>
    